import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VDropdownHeader' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ''
		},
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    role: "none",
    class: _normalizeClass(_unref(clsx)(__props.className, 'col-span-5 px-3.5 pb-1 pt-2.5 sm:px-3'))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})